var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDonutChart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8.964 1.995c2.815.51 5 3.113 5 5.91 0 3.12-2.818 6-6 6-3.378 0-6-2.88-6-6q0-.258.024-.511l3.037 1.092c.276 1.319 1.463 2.419 2.939 2.419 1.591 0 3-1.44 3-3 0-1.228-.842-2.381-2-2.817ZM7.964 0v4.975c-1.692 0-2.216.812-2.675 1.69l-.124.24-.126.24L0 4.975C1.43 2.11 4.446.107 7.964 0"
})));
export default SvgDonutChart;